import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { UiModule } from 'src/app/ui/ui.module';
import { CertificationsComponent } from './certifications/certifications.component';
import { EquipmentDashboardComponent } from './equipment/equipment.component';
import { CreatePersonaComponent } from './create-persona/create-persona.component';
import { CompanyComponent } from './profile/company/company.component';
import { ProfileSectionComponent } from './profile/profile-section/profile-section.component';
import { WorkingHoursComponent } from './profile/working-hours/working-hours.component';
import { ProfileComponent } from './profile/profile.component';
import { AuthGuardService as AuthGuard } from 'src/app/services/auth/auth-guard.service';
import { FinanceComponent } from './finance/finance.component';
import { DashboardPersonaFinanceGeneralComponent } from './finance/general/general.component';
import { DashboardPersonaFinanceCostComponent } from './finance/costs/costs.component';
import { OperationsComponent } from './operations/operations.component';
import { DashboardPersonaOperationsGeneralComponent } from './operations/general/general.component';
import { DashboardPersonaOperationsKpiComponent } from './operations/kpi/kpi.component';
import { DashboardPersonaOperationsDomainComponent } from './operations/domain/domain.component';
import { DashboardPersonaOperationsOrganizationChartComponent } from './operations/organization-chart/organization-chart.component';
import { VariableCompensationComponent } from './variable-compensation/variable-compensation.component';
import { DashboardPersonaVariableCompensationGeneralComponent } from './variable-compensation/general/general.component';
import { PersonaCertificationGeneralComponent } from './certifications/general/general.component';
import { DashboardPersonaCertificationAchievementsComponent } from './certifications/achievements/achievements.component';
import { RelationshipComponent } from './relationship/relationship.component';
import { EmployeesComponent } from './relationship/employees/employees.component';
import { SuppliersComponent } from './relationship/suppliers/suppliers.component';
import { DashboardAccountComponent } from './account/account.component';
import { GdprDashboardComponent } from './gdpr/gdpr.component';
import { DashboardGdprPdpaComponent } from './gdpr/pdpa/pdpa.component';
import { DashboardGdprSadComponent } from './gdpr/sad/sad.component';
import { DashboardAccountGeneralComponent } from './account/general/general.component';
import { DashboardIdentificationComponent } from './identification/identification.component';
import { DashboardIdentificationGeneralComponent } from './identification/general/general.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PersonasComponent } from './personas/personas.component';
import { BreadcrumbsComponent } from '../../ui/breadcrumbs/breadcrumbs.component';
import { ComputerComponent } from './equipment/computer/computer.component';
import { SimcardComponent } from './equipment/simcard/simcard.component';
import { CompanyCarComponent } from './equipment/company-car/company-car.component';
import { FuelCardComponent } from './equipment/fuel-card/fuel-card.component';
import { TelepassComponent } from './equipment/telepass/telepass.component';
import { ElectronicMealCardComponent } from './equipment/electronic-meal-card/electronic-meal-card.component';
import { OfficeaccesskeyComponent } from './equipment/officeaccesskey/officeaccesskey.component';
import { PersonaExistsInfoComponent } from './create-persona/persona-exists-info/persona-exists-info.component';
import { ImportPersonaComponent } from './import-persona/import-persona.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { PersonasRedirectGuardService } from 'src/app/services/auth/personas-redirect-guard.service';
type PathMatch = "full" | "prefix" | undefined;
const routes: Routes = [
  /*
  { path: '',
    component: DashboardComponent,
    data: { title: 'dashboard.title' },
    canActivate: [PersonasRedirectGuardService],
    pathMatch: 'full' as PathMatch },*/
  {
    path: 'personas',
    component: PersonasComponent,
    canActivate: [AuthGuard],
    data: {  title: 'dashboard.menu.personas.pageTitle' }
  },
  {
    path: 'profile',
    component: ProfileComponent,
    data: {  title: 'dashboard.menu.profile.pageTitle' },
    children: [
      {
        path: 'company',
        component: CompanyComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.profileSubmenu.company.pageTitle' }
      },
      {
        path: 'personal',
        component: ProfileSectionComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.profileSubmenu.personal.pageTitle' }
      },
      {
        path: 'workinghours',
        component: WorkingHoursComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.profileSubmenu.workingHours.pageTitle' }
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'relationship',
    component: RelationshipComponent,
    data: {  title: 'dashboard.menu.profile.pageTitle' },
    children: [
      {
        path: 'employees',
        component: EmployeesComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.relationshipSubmenu.employees.pageTitle' }
      },
      {
        path: 'suppliers',
        component: SuppliersComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.relationshipSubmenu.suppliers.pageTitle' }
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'finance',
    component: FinanceComponent,
    data: {  title: 'dashboard.menu.finance.pageTitle' },
    children: [
      {
        path: 'general',
        component: DashboardPersonaFinanceGeneralComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.financeSubmenu.general.pageTitle' }
      },
      {
        path: 'cost',
        component: DashboardPersonaFinanceCostComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.financeSubmenu.costs.pageTitle' }
      },
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'operations',
    component: OperationsComponent,
    data: {  title: 'dashboard.menu.operations.pageTitle' },
    children: [
      {
        path: 'general',
        component: DashboardPersonaOperationsGeneralComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.operationsSubmenu.general.pageTitle' }
      },
      {
        path: 'organization-chart',
        component: DashboardPersonaOperationsOrganizationChartComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.operationsSubmenu.organizationChart.pageTitle' }
      },
      {
        path: 'domain',
        component: DashboardPersonaOperationsDomainComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.operationsSubmenu.domain.pageTitle' }
      },
      {
        path: 'kpi',
        component: DashboardPersonaOperationsKpiComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.operationsSubmenu.kpi.pageTitle' }
      },
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'variablecompensation',
    component: VariableCompensationComponent,
    data: {  title: 'dashboard.menu.variablecompensation.pageTitle' },
    children: [
      {
        path: 'general',
        component: DashboardPersonaVariableCompensationGeneralComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.variablecompensationSubmenu.general.pageTitle' }
      },
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'certification',
    component: CertificationsComponent,
    data: {  title: 'dashboard.menu.certification.pageTitle' },
    children: [
      {
        path: 'general',
        component: PersonaCertificationGeneralComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.certificationsSubmenu.general.pageTitle' }
      },
      {
        path: 'achievement',
        component: DashboardPersonaCertificationAchievementsComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.certificationsSubmenu.achievements.pageTitle' }
      },
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'account',
    component: DashboardAccountComponent,
    data: {  title: 'dashboard.menu.account.pageTitle' },
    children: [
      {
        path: 'general',
        component: DashboardAccountGeneralComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.accountsSubmenu.general.pageTitle' }
      },
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'gdpr',
    component: GdprDashboardComponent,
    data: {  title: 'dashboard.menu.account.pageTitle' },
    children: [
      {
        path: 'personaldataprocessingauthorization',
        component: DashboardGdprPdpaComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.accountsSubmenu.general.pageTitle' }
      },
      {
        path: 'systemadministratordesignation',
        component: DashboardGdprSadComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.accountsSubmenu.general.pageTitle' }
      },
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'identification',
    component: DashboardIdentificationComponent,
    data: {  title: 'dashboard.menu.identification.pageTitle' },
    children: [
      {
        path: 'general',
        component: DashboardIdentificationGeneralComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.identificationSubmenu.general.pageTitle' }
      },
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'equipment',
    component: EquipmentDashboardComponent,
    canActivate: [AuthGuard],
    data: { title: 'dashboard.menu.equipment.pageTitle' },
    children: [
      {
        path: 'computer',
        component: ComputerComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.equipmentSubmenu.computer.pageTitle' }
      },
      {
        path: 'companycar',
        component: CompanyCarComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.equipmentSubmenu.companyCar.pageTitle' }
      },
      {
        path: 'fuelcard',
        component: FuelCardComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.equipmentSubmenu.fuelCard.pageTitle' }
      },
      {
        path: 'simcard',
        component: SimcardComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.equipmentSubmenu.simCard.pageTitle' }
      },
      {
        path: 'telepass',
        component: TelepassComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.equipmentSubmenu.telepass.pageTitle' }
      },
      {
        path: 'electronicmealcard',
        component: ElectronicMealCardComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.equipmentSubmenu.electronicMealCard.pageTitle' }
      },
      {
        path: 'officeaccesskey',
        component: OfficeaccesskeyComponent,
        canActivate: [AuthGuard],
        data: { title: 'dashboard.menu.equipmentSubmenu.officeAccessKey.pageTitle' }
      },
    ]
  },
  { path: '**', redirectTo: 'personas', pathMatch:  'full' as PathMatch},
];

@NgModule({
  declarations: [
    DashboardComponent,
    CertificationsComponent,
    ProfileComponent,
    CreatePersonaComponent,
    CompanyComponent,
    ProfileSectionComponent,
    WorkingHoursComponent,
    FinanceComponent,
    DashboardPersonaFinanceGeneralComponent,
    DashboardPersonaFinanceCostComponent,
    OperationsComponent,
    DashboardPersonaOperationsGeneralComponent,
    DashboardPersonaOperationsKpiComponent,
    DashboardPersonaOperationsDomainComponent,
    DashboardPersonaOperationsOrganizationChartComponent,
    VariableCompensationComponent,
    DashboardPersonaVariableCompensationGeneralComponent,
    PersonaCertificationGeneralComponent,
    DashboardPersonaCertificationAchievementsComponent,
    RelationshipComponent,
    EmployeesComponent,
    SuppliersComponent,
    DashboardAccountComponent,
    GdprDashboardComponent,
    DashboardGdprPdpaComponent,
    DashboardGdprSadComponent,
    DashboardAccountGeneralComponent,
    DashboardIdentificationComponent,
    DashboardIdentificationGeneralComponent,
    PersonasComponent,
    BreadcrumbsComponent,
    ComputerComponent,
    SimcardComponent,
    CompanyCarComponent,
    FuelCardComponent,
    TelepassComponent,
    ElectronicMealCardComponent,
    EquipmentDashboardComponent,
    OfficeaccesskeyComponent,
    PersonaExistsInfoComponent,
    ImportPersonaComponent
  ],
  imports: [
    CommonModule, 
    UiModule, 
    NgbModule, 
    RouterModule.forChild(routes),
    InlineSVGModule.forRoot()
  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class DashboardModule {}
